export enum Permission {
  FoodstormOmsView = 'foodstorm_oms.view',
  FoodstormOmsModify = 'foodstorm_oms.modify',
  EnterpriseCustomersModify = 'enterprise_customers.modify',
}
